import { useCallback } from 'react';
import { useAuth } from '../auth/useAuth';
import type { AuthArgs } from '../api/authArgs';

/**
 * Resolves the current user's {@link AuthArgs} (MSAL bearer + identity hints) for authenticated API
 * calls. Returns a stable async function; it resolves to null when no user is signed in or a token
 * cannot be acquired, so callers can short-circuit the request.
 */
export function useAuthArgs(): () => Promise<AuthArgs | null> {
  const { account, acquireApiToken } = useAuth();
  return useCallback(async (): Promise<AuthArgs | null> => {
    if (!account?.homeAccountId) {
      return null;
    }
    const bearer = await acquireApiToken();
    if (!bearer) {
      return null;
    }
    return {
      authBearer: bearer,
      homeAccountId: account.homeAccountId,
      username: account.username,
      displayName: account.name,
    };
  }, [account, acquireApiToken]);
}
